import React, { Component } from "react";
import Header from "../../Header";
import Announcements from "../announcement/Announcements";
import Events from "../event/Events";
import JobOffers from "../job/JobOffers";
import NewsList from "../news/NewsList";
import "./Homepage.css";
import Search from "../search/Search";

class Homepage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: "all",
    };
    this.changeTab = this.changeTab.bind(this);
  }

  changeTab(e) {
    e.preventDefault();
    let target = e.target.id;
    this.setState({ currentTab: target });
  }

  render() {
    const { currentTab } = this.state;
    return (
      <div>
        <Header linkLeftButton="search" pageTitle="Accueil"></Header>
        <div className="homepage__header">
          <div className="homepage__navbar">
            <div id="all" className={`homepage__navlink ${currentTab === "all" ? "active" : ""}`} onClick={this.changeTab}>
              <svg id="all" xmlns="http://www.w3.org/2000/svg" width="21" height="10" viewBox="0 0 21 10">
                <path
                  id="all"
                  data-name="Combined Shape"
                  d="M6.974,10c-.383,0-.695-.2-.695-.436v-1.4c0-.24.311-.437.695-.437H20.306c.383,0,.694.2.694.437v1.4c0,.241-.31.436-.694.436ZM3.834,6.251c-.383,0-.694-.2-.694-.437v-1.4c0-.24.311-.436.694-.436H17.166c.383,0,.695.2.695.436v1.4c0,.241-.311.437-.695.437ZM.694,2.269C.31,2.269,0,2.074,0,1.832V.437C0,.2.31,0,.694,0H14.027c.383,0,.694.2.694.437v1.4c0,.241-.311.437-.694.437Z"
                />
              </svg>
            </div>
            <div id="news" className={`homepage__navlink ${currentTab === "news" ? "active" : ""}`} onClick={this.changeTab}>
              <svg id="news" xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 24 19">
                <path
                  id="news"
                  data-name="Combined Shape"
                  d="M4.6,19H2.627A2.625,2.625,0,0,1,0,16.382V5.567A2.618,2.618,0,0,1,1.974,3.035V2.617A2.625,2.625,0,0,1,4.6,0H21.373A2.625,2.625,0,0,1,24,2.617V16.382A2.625,2.625,0,0,1,21.373,19ZM1.307,5.567V16.382A1.32,1.32,0,0,0,2.627,17.7H21.373a1.319,1.319,0,0,0,1.319-1.316V2.617A1.319,1.319,0,0,0,21.373,1.3H4.6A1.319,1.319,0,0,0,3.281,2.617V16.382a.653.653,0,0,1-1.307,0V4.432A1.318,1.318,0,0,0,1.307,5.567ZM14.821,15.7a.624.624,0,0,1,0-1.247h6.116a.624.624,0,0,1,0,1.247Zm-9.755,0a.626.626,0,0,1-.626-.624V9.5a.626.626,0,0,1,.626-.624H12.52a.626.626,0,0,1,.626.624v5.572a.626.626,0,0,1-.626.624Zm.626-1.247h6.2V10.124h-6.2Zm9.13-1.538a.625.625,0,0,1,0-1.248h6.116a.625.625,0,0,1,0,1.248Zm0-2.785a.625.625,0,0,1,0-1.248h6.116a.625.625,0,0,1,0,1.248ZM5.066,7.338a.624.624,0,1,1,0-1.247H20.907a.624.624,0,1,1,0,1.247Zm0-2.786a.624.624,0,1,1,0-1.247H20.907a.624.624,0,1,1,0,1.247Z"
                />
              </svg>
            </div>
            <div id="event" className={`homepage__navlink ${currentTab === "event" ? "active" : ""}`} onClick={this.changeTab}>
              <svg id="event" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path
                  id="event"
                  data-name="Combined Shape"
                  d="M17.162,20H2.838A2.874,2.874,0,0,1,0,17.1V4.8A2.874,2.874,0,0,1,2.838,1.9h.943V.853a.835.835,0,1,1,1.67,0V1.9h9.1V.853a.835.835,0,1,1,1.669,0V1.9h.943A2.874,2.874,0,0,1,20,4.8V17.1A2.874,2.874,0,0,1,17.162,20ZM1.669,8.061V17.1a1.184,1.184,0,0,0,1.169,1.2H17.162a1.184,1.184,0,0,0,1.169-1.2V8.061ZM2.838,3.6A1.184,1.184,0,0,0,1.669,4.8V6.354H18.331V4.8a1.184,1.184,0,0,0-1.169-1.2h-.943v.633a.835.835,0,1,1-1.669,0V3.6H5.45v.633a.835.835,0,1,1-1.67,0V3.6Z"
                />
              </svg>
            </div>
            <div
              id="announcement"
              className={`homepage__navlink ${currentTab === "announcement" ? "active" : ""}`}
              onClick={this.changeTab}
            >
              <svg id="announcement" xmlns="http://www.w3.org/2000/svg" width="26" height="21" viewBox="0 0 26 21">
                <path
                  id="announcement"
                  data-name="Combined Shape Copy"
                  d="M8.2,19.868,5.86,14.96l-1.2.294a3.825,3.825,0,0,1-.906.111,3.713,3.713,0,0,1-1.947-.554,3.784,3.784,0,0,1-1.7-2.372,3.851,3.851,0,0,1,.453-2.9A3.794,3.794,0,0,1,2.782,7.844l.041-.012,2.9-.763c3.773-.929,7.054-4.9,7.97-6.091a.321.321,0,0,1,.065-.063,1.487,1.487,0,0,1,.955-.881A1.237,1.237,0,0,1,14.995,0c1.76,0,3.461,3.846,4.366,7.657a22.6,22.6,0,0,1,.683,5.781c-.089,2.353-.812,3.02-1.4,3.165a1.2,1.2,0,0,1-.284.034,1.627,1.627,0,0,1-.976-.375,19.751,19.751,0,0,0-7.45-1.979L11.756,18.1a2.034,2.034,0,0,1-.911,2.693,1.932,1.932,0,0,1-.862.2A1.989,1.989,0,0,1,8.2,19.868Zm.2-2.16.8,1.668a.878.878,0,0,0,.5.45.866.866,0,0,0,.286.049.839.839,0,0,0,.379-.09.873.873,0,0,0,.442-.508.9.9,0,0,0-.04-.679l-.775-1.622ZM7.646,14.52l-.687.169.958,2.005L9.5,15.962l-.778-1.629A8.122,8.122,0,0,0,7.646,14.52ZM14.413,3.243a15.786,15.786,0,0,0,.084,2.14c1.067.165,2.038,1.346,2.416,2.939s.046,3.08-.82,3.729a9.174,9.174,0,0,0,1.891,3.26l.093.049.014.007a.533.533,0,0,1,.146.113.315.315,0,0,0,.122.031c.2-.045.527-.659.582-2.118a21.466,21.466,0,0,0-.653-5.472c-1.058-4.462-2.705-6.8-3.292-6.8C14.8,1.171,14.468,1.786,14.413,3.243Zm1.545,11.181A17.264,17.264,0,0,1,14.925,12.1a.565.565,0,0,1-.082-.182l-.006-.063a28.123,28.123,0,0,1-.844-2.874,27.7,27.7,0,0,1-.526-2.871l0-.015a.235.235,0,0,1-.006-.075,17.773,17.773,0,0,1-.147-2.82V3.187C11.912,4.733,9.1,7.44,5.984,8.208L4.3,8.624l1.246,5.255,1.842-.454a9.951,9.951,0,0,1,2.382-.273A18.163,18.163,0,0,1,15.958,14.423ZM3.132,8.912A2.676,2.676,0,0,0,1.5,10.126a2.714,2.714,0,0,0-.319,2.048,2.669,2.669,0,0,0,1.2,1.673,2.62,2.62,0,0,0,1.376.391,2.7,2.7,0,0,0,.647-.08l.066-.015L3.225,8.889Zm11.934-.2c.175.74.378,1.463.6,2.15a3.215,3.215,0,0,0,.171-2.278,3.154,3.154,0,0,0-1.183-1.953C14.765,7.331,14.9,8.032,15.066,8.716Zm10.248,4.289-2.782-.7a.547.547,0,0,1-.341-.256.571.571,0,0,1-.063-.426.561.561,0,0,1,.25-.347.543.543,0,0,1,.419-.064l2.784.7a.55.55,0,0,1,.34.256.572.572,0,0,1,.063.426.556.556,0,0,1-.442.42.548.548,0,0,1-.094.008A.527.527,0,0,1,25.314,13.005ZM22.128,7.627A.555.555,0,0,1,21.6,7.2a.565.565,0,0,1,.405-.681l2.511-.628a.542.542,0,0,1,.417.065.558.558,0,0,1,.251.348.564.564,0,0,1-.405.68l-2.511.628a.538.538,0,0,1-.13.016ZM20.223,3.345a.546.546,0,0,1-.4-.2.57.57,0,0,1,.062-.794L22.153.391a.546.546,0,0,1,.779.065.568.568,0,0,1,.13.41.562.562,0,0,1-.193.383L20.6,3.212a.543.543,0,0,1-.356.134Z"
                  transform="translate(0)"
                />
              </svg>
            </div>
            <div id="jobOffer" className={`homepage__navlink ${currentTab === "jobOffer" ? "active" : ""}`} onClick={this.changeTab}>
              <svg id="jobOffer" xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 23 20">
                <path
                  id="jobOffer"
                  data-name="Combined Shape"
                  d="M20.546,20H2.454a1.374,1.374,0,0,1-1.39-1.354V11.1C.844,11,.608,10.9.374,10.792A.648.648,0,0,1,0,10.21l.013-5.63A1.373,1.373,0,0,1,1.4,3.226H7.556V1.805A1.831,1.831,0,0,1,9.408,0h4.185a1.831,1.831,0,0,1,1.852,1.805V3.226H21.6a1.375,1.375,0,0,1,1.39,1.354L23,10.063a.646.646,0,0,1-.354.573c-.222.113-.455.226-.711.343v7.667A1.374,1.374,0,0,1,20.546,20ZM2.391,11.6v7.042a.065.065,0,0,0,.063.061H20.546a.069.069,0,0,0,.064-.061V11.524a24.13,24.13,0,0,1-6.738,1.348v.508a1.053,1.053,0,0,1-1.066,1.038H10.2A1.053,1.053,0,0,1,9.13,13.379v-.5A25.391,25.391,0,0,1,2.391,11.6Zm8.064.283v1.238h2.09V11.887ZM1.4,4.519a.066.066,0,0,0-.064.062L1.328,9.8a22.634,22.634,0,0,0,7.8,1.783,1.054,1.054,0,0,1,1.065-.989h2.611a1.055,1.055,0,0,1,1.063.978,21.221,21.221,0,0,0,7.8-1.9l-.011-5.088a.067.067,0,0,0-.064-.063ZM9.408,1.292a.52.52,0,0,0-.527.513V3.226h5.238V1.805a.527.527,0,0,0-.527-.513Z"
                />
              </svg>
            </div>
          </div>
        </div>

        {currentTab === "all" ? (
          <div className="homepage__wrapper">
            <div className="homepage__container">
              <div className="homepage__container-title">Fil d'actualité</div>
              <Search displayMenu={true}></Search>
            </div>
          </div>
        ) : (
          ""
        )}

        {currentTab === "news" ? (
          <div className="homepage__wrapper">
            <div className="homepage__container">
              <div className="homepage__container-title">News</div>
              <NewsList companyId={""}></NewsList>
            </div>
          </div>
        ) : (
          ""
        )}

        {currentTab === "event" ? (
          <div className="homepage__wrapper">
            <div className="homepage__container">
              <div className="homepage__container-title">Événements</div>
              <Events companyId={""}></Events>
            </div>
          </div>
        ) : (
          ""
        )}

        {currentTab === "announcement" ? (
          <div className="homepage__wrapper">
            <div className="homepage__container">
              <div className="homepage__container-title">Annonces</div>
              <Announcements userId={""}></Announcements>
            </div>
          </div>
        ) : (
          ""
        )}

        {currentTab === "jobOffer" ? (
          <div className="homepage__wrapper">
            <div className="homepage__container">
              <div className="homepage__container-title">Offres d'emploi</div>
              <JobOffers companyId={""}></JobOffers>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default Homepage;
